import './documents.css'

// "What the documents say" (REQ-120): every fact a document gave an opportunity, as the value with the file and
// the place it was read from in muted words; the quote it stands on is the tooltip. Read-only here — a fact is
// moved (confirmed, marked not right) on the contact card where it also lands.

export interface DocumentFactLine { documentId: string; documentName: string; key: string; value: string; quote?: string | null; where?: string | null }

export function DocumentFacts({ facts, compact = false }: { facts: DocumentFactLine[]; compact?: boolean }) {
  if (facts.length === 0) return null
  return (
    <ul className={`plain document-facts${compact ? ' compact' : ''}`} aria-label="What the documents say">
      {facts.map((f, i) => (
        <li key={`${f.documentId}-${f.key}-${i}`} className="document-fact" title={f.quote ?? undefined}>
          <span className="document-fact-value"><span className="muted document-fact-key">{f.key}</span> {f.value}</span>
          <span className="muted small document-fact-where">{f.documentName}{f.where ? `, ${f.where}` : ''}</span>
        </li>
      ))}
    </ul>
  )
}
